import React, { useEffect, useRef } from 'react';
import { TURNSTILE_SITE_KEY } from '../config';

// Cloudflare Turnstile widget (script loaded in public/index.html). Renders nothing
// when REACT_APP_TURNSTILE_SITE_KEY is unset; the backend skips verification then too.
// Tokens are single-use: remount it (change its key) to get a fresh one.
const TurnstileWidget = ({ onToken }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!TURNSTILE_SITE_KEY || !containerRef.current) return undefined;

    let widgetId;
    let cancelled = false;

    const renderWidget = () => {
      if (cancelled || !window.turnstile || !containerRef.current) return;
      widgetId = window.turnstile.render(containerRef.current, {
        sitekey: TURNSTILE_SITE_KEY,
        callback: onToken,
        'expired-callback': () => onToken(''),
        'error-callback': () => onToken(''),
      });
    };

    if (window.turnstile) {
      renderWidget();
    } else {
      const interval = setInterval(() => {
        if (window.turnstile) {
          clearInterval(interval);
          renderWidget();
        }
      }, 200);
      return () => {
        cancelled = true;
        clearInterval(interval);
        if (widgetId !== undefined && window.turnstile) window.turnstile.remove(widgetId);
      };
    }

    return () => {
      cancelled = true;
      if (widgetId !== undefined && window.turnstile) window.turnstile.remove(widgetId);
    };
  }, [onToken]);

  if (!TURNSTILE_SITE_KEY) return null;

  return <div ref={containerRef} className="mt-4 flex justify-center" />;
};

export default TurnstileWidget;
